<template>
	<b-card no-body>
		<b-row>
			<b-col>
				<b-table
					:items="competitionData"
					:fields="fields"
					primary-key="id"
					:sort-by.sync="sortBy"
					:sort-desc.sync="isSortDirDesc"
					class="position-relative"
					show-empty
					striped
					empty-text="No se encontraron registros coincidentes"
				>
					<template #table-busy>
						<div class="text-center text-primary my-2">
							<b-spinner class="align-middle mb-1"></b-spinner>
							<div>
								<b>CARGANDO</b>
							</div>
						</div>
					</template>
					
					<template #head(download)="data">
						<span v-html="data.label"></span>
					</template>

					<template #cell(bidder_name)="data">
						<div style="width: 500px; text-transform: uppercase;">
							{{ data.item.bidder_name }}
						</div>
					</template>

					<template #cell(competition_state)="data">
						<div class="text-nowrap">
							<b-badge
								:variant="`light-${data.item.competition_state_color}`"
							>{{ data.item.competition_state }}</b-badge>
						</div>
					</template>

					<template #cell(download)="data">
						<div class="text-nowrap">
							<b-button
								v-ripple.400="'rgba(113, 102, 240, 0.15)'"
								variant="outline-info"
								size="sm"
								:disabled="downloadingId === data.item.id"
								@click="downloadCompetitionFiles(data.item.id)"
							>
								<b-spinner
									v-if="downloadingId === data.item.id"
									small
									class="mr-50"
								/>
								<feather-icon
									v-else
									icon="DownloadCloudIcon"
									class="mr-50"
								/>
								<span>{{ downloadingId === data.item.id ? 'Descargando...' : 'Descargar' }}</span>
							</b-button>
						</div>
					</template>

					<template #cell(finished_at)="data">
						<div
							class="text-nowrap"
						>{{ data.item.finished_at ? moment(data.item.finished_at).format("DD-MM-YYYY HH:mm") : "-" }}</div>
					</template>

					<template #cell(actions)="data">
						<b-button
							variant="outline-primary"
							:to="{
								name: 'tenders-bidder-review',
								params: {
									id: data.item.tender_id,
									competition_review_id: data.item.competition_review_id
								}
					}"
						>{{ isDisabled || data.item.status || !isAssigned ? 'Ver Propuestas' : 'Evaluar Propuestas' }}</b-button>
					</template>
				</b-table>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import { ref } from "@vue/composition-api"
import useNotifications from "@notifications"
import Ripple from "vue-ripple-directive"
import axios from "@axios"
import moment from "moment"

export default {
	directives: {
		Ripple
	},
	data() {
		return {
			moment
		}
	},
	props: {
		isDisabled: {
			type: Boolean,
			default: false
		},
		competitionData: {
			type: Array,
			required: true
		},
		isAssigned: {
			type: Boolean,
			required: true
		}
	},
	setup(props) {
		const { swalNotification } = useNotifications()

		const perPage = ref(10)
		const currentPage = ref(1)
		const perPageOptions = [10, 25, 50, 100]
		const sortBy = ref("id")
		const isSortDirDesc = ref(false)
		const downloadingId = ref(null)

		const styleColumns = {
			thClass: "text-center",
			tdClass: "text-center"
		}

		const items = ref([])

		const fields = ref([
			{ key: "bidder_name", label: "POSTOR", thClass: styleColumns.thClass },
			{
				key: "competition_state",
				label: "ESTADO DE LICITACIÓN",
				...styleColumns
			},
			{ key: "finished_at", label: "FECHA DE ENVÍO", ...styleColumns },
			{ key: "download", label: "DESCARGA MASIVA <br /> DOCS Y PROPUESTAS", ...styleColumns },
			{ key: "actions", label: "OPCIONES", ...styleColumns }
		])

		const downloadCompetitionFiles = async (competitionId) => {
			downloadingId.value = competitionId
			try {
				const response = await axios.get(
					`/files/download-competition/${competitionId}`,
					{ responseType: "blob" }
				)

				const contentDisposition = response.headers["content-disposition"]
				let fileName = "archivos.zip"
				if (contentDisposition) {
					const match = contentDisposition.match(/filename="?(.+?)"?$/)
					if (match) fileName = match[1]
				}

				const url = window.URL.createObjectURL(new Blob([response.data]))
				const link = document.createElement("a")
				link.href = url
				link.setAttribute("download", fileName)
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
				window.URL.revokeObjectURL(url)

				swalNotification("Archivos descargados con éxito")
			} catch (error) {
				const message = error.response
					? "No se encontraron archivos para descargar"
					: "Error al descargar archivos"
				swalNotification(message, false)
			} finally {
				downloadingId.value = null
			}
		}

		return {
			items,
			fields,

			perPage,
			currentPage,
			perPageOptions,
			sortBy,
			isSortDirDesc,
			downloadingId,

			downloadCompetitionFiles
		}
	}
}
</script>
